package org.example.site_web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ListStyleType
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.example.site_web.aiPalette
import org.example.site_web.components.images.AccTriangleIcon
import org.example.site_web.components.layouts.PageLayoutData
import org.example.site_web.content.page.offersContent_Manifest1
import org.example.site_web.content.page.offersContent_Manifest2
import org.example.site_web.content.page.offersContent_Part2
import org.example.site_web.content.page.offersContent_Part3
import org.example.site_web.content.page.offersContent_Part3List
import org.example.site_web.content.page.offersContent_Part4
import org.example.site_web.content.page.offersContent_Part4LC
import org.example.site_web.content.page.offersContent_Part4List
import org.example.site_web.content.page.offersContent_Part5
import org.example.site_web.content.page.offersContent_Part5List
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

val offers2PageStyle = CssStyle {

    base {
        Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .padding(left=3.vw,right = 3.vw)
            .fontSize(1.cssRem)
    }

    Breakpoint.MD {
        Modifier.padding(leftRight = 10.vw)
    }

    Breakpoint.LG {
        Modifier.padding(leftRight = 15.vw)
    }

    Breakpoint.XL{
        Modifier.padding(leftRight = 22.vw)
    }

}

val manifest2Style = CssStyle {
    base {
        Modifier
            //.border(color = aiPalette.optPalette.primary, style = LineStyle.Solid, width = 1.px)
            //.boxShadow(spreadRadius = 0.25.em, blurRadius = 0.25.em, color = aiPalette.optPalette.primary, inset = false)
            .borderLeft {
                color(aiPalette.mainPalette.primary)
                style(LineStyle.Solid)
                width(2.px)
            }
            .borderRight {
                color(aiPalette.mainPalette.primary)
                style(LineStyle.Solid)
                width(2.px)
            }
            .padding(leftRight = 1.0.cssRem)
            .margin(topBottom = 1.5.cssRem)
    }
}

val listBulletStyle = CssStyle {
    cssRule("::marker") {
        Modifier
            .color(aiPalette.mainPalette.darkest)
    }
}



@InitRoute
fun initOffersPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Notre Offre"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun OffersPage() {
    Column(
        offers2PageStyle.toModifier(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.SpaceAround
    ) {

        Box(
            Modifier
                .fillMaxWidth()
                .fontSize(2.0.cssRem)
                .fontWeight(FontWeight.Bold)
                .margin(top = 1.5.cssRem),
            contentAlignment = Alignment.BottomStart
        ) {
            Span() {
                AccTriangleIcon()
                Text("Notre Offre")
            }
        }

        Box(
            manifest2Style.toModifier()
                .fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier
                    .whiteSpace(WhiteSpace.PreWrap)
                    .textAlign(TextAlign.Center).toAttrs()
            ) {
                Text(offersContent_Manifest1)
            }
        }

        Column(
            Modifier
                .fillMaxWidth()
                .margin(topBottom = 1.5.cssRem)
                .borderLeft {
                    color(aiPalette.mainPalette.darkest)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                .borderRight {
                    color(aiPalette.mainPalette.darkest)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                .padding(leftRight = 1.0.cssRem)
                .margin(topBottom = 1.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Span(
                Modifier.textAlign(TextAlign.Center)
                    .textDecorationLine(TextDecorationLine.None).toAttrs()
            ) {
                Text(offersContent_Part2)
                Br()
                Br()
                Span(Modifier.whiteSpace(WhiteSpace.PreWrap).toAttrs()) {
                    Text(offersContent_Part3)
                }
            }
            Box() {
                Ul(
                    Modifier.listStyle(
                        type = ListStyleType.Square
                    ).toAttrs()
                ) {
                    for (entry in offersContent_Part3List) {
                        Li(listBulletStyle.toAttrs()) {
                            Span() {
                                Text(entry)
                            }
                        }
                    }
                }
            }

        }


        Box(
            manifest2Style.toModifier().fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier
                    .textAlign(TextAlign.Center)
                    .whiteSpace(WhiteSpace.PreWrap).toAttrs()
            ) {
                Text(offersContent_Manifest2.uppercase())
            }
        }


        Column(
            Modifier.margin(topBottom = 1.5.cssRem)
                .borderLeft {
                    color(aiPalette.mainPalette.darkest)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                .borderRight {
                    color(aiPalette.mainPalette.darkest)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                //.padding(left = 1.0.cssRem)
                .margin(top = 1.5.cssRem)
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Span(Modifier
                .textAlign(TextAlign.Center).toAttrs()) {
                Text(offersContent_Part4)
            }
            Column(
                Modifier.margin(top = 0.5.cssRem),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                for (i in 0..<offersContent_Part4List.size) {

                    Column(Modifier.fillMaxWidth()
                        .backgroundColor(aiPalette.mainPalette.darkest)
                        .color(Colors.White)
                        .margin(top = 1.5.cssRem),
                        verticalArrangement = Arrangement.Top,
                        horizontalAlignment = Alignment.CenterHorizontally)
                    {
                        Box(
                            Modifier

                                .padding(leftRight = 1.5.cssRem, topBottom = 0.75.cssRem),
                            contentAlignment = Alignment.Center
                        ) {
                            Span(Modifier.textAlign(TextAlign.Center).toAttrs()) {
                                Text(offersContent_Part4List[i])
                            }
                        }
                        Box(
                            Modifier
                                .backgroundColor(aiPalette.mainPalette.darkest)
                                .color(Colors.White)
                                .margin(bottom = 0.5.cssRem)
                                .padding(leftRight = 1.5.cssRem, bottom = 0.75.cssRem),
                            contentAlignment = Alignment.CenterStart
                        ) {
                            Ul(Modifier.listStyle(
                                type= ListStyleType.Square).toAttrs()) {
                                for (entry in offersContent_Part4LC[i]) {
                                    Li() {
                                        Span() {
                                            Text(entry)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        Box(
            Modifier
                .borderLeft {
                    color(aiPalette.mainPalette.primary)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                .borderRight {
                    color(aiPalette.mainPalette.primary)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                //.padding(left = 1.0.cssRem)
                .margin(top = 1.5.cssRem)
                .margin(topBottom = 1.5.cssRem).fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier
                    .color(Colors.White)
                    .fontSize(1.2.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .textAlign(TextAlign.Center).toAttrs()
            ) {
                Text(offersContent_Part5)
            }
        }

        Column(
            Modifier
                .padding(1.5.cssRem)
                .border(color = aiPalette.mainPalette.primary, style = LineStyle.Solid, width = 0.25.cssRem)
                .margin(top = 2.cssRem, bottom = 1.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Span(Modifier
                .margin(bottom = 1.5.cssRem)
                .fontWeight(FontWeight.Bold).toAttrs()) {
                Text("Exemples de sujets et projets que nous pouvons réaliser")
            }
            for (entry in offersContent_Part5List) {
                Box(Modifier.margin(topBottom = 1.cssRem),
                    contentAlignment = Alignment.Center) {
                        Span(Modifier.textAlign(TextAlign.Center).toAttrs()) {
                            AccTriangleIcon(Modifier.attr("fill","white"))
                            Span(Modifier.fontWeight(FontWeight.Bold).toAttrs()) {Text(entry.first)}
                            Br()
                            Span(Modifier.whiteSpace(WhiteSpace.PreWrap).toAttrs()) {
                                Text(entry.second)
                            }
                            Br()
                        }

                }
            }
        }
    }
}


